module.exports = __webpack_public_path__ + "img/step2-text.6c25ace4.png";